<!-- 生成电子订单-->
<template>
  <div class="rfq-inquiry-list p5 m5 bw br5" :key="pageKey">
    <span>
      <div class="pb10">
        <div class="block-item poi fix" @click="isShowBlock1 = !isShowBlock1">
          <span class="block-item-title">基本信息</span>
          <q-icon name="fas fa-angle-down" color="blue-grey-2" v-if="isShowBlock1"/>
          <q-icon name="fas fa-angle-up" color="blue-grey-2" v-else/>
        </div>
        <div>
          <base-form :formSet="{data:this.formSet}" :showRow="2" :isShowBlock="isShowBlock1"/>
        </div>
      </div>
      <div class="pb10">
        <div class="block-item poi fix" >
          <span class="block-item-title">金额信息</span>
        </div>
        <div>
          <base-form :formSet="{data:this.formSet2}"/>
        </div>
      </div>
      <div class="row">
         <div class="col-5 pr5">
            <div class="block-item poi fix">
              <span class="block-item-title l" style="padding-bottom: 6px">特价单</span>
            </div>
            <div>
              <q-skeleton :height="tableSet.height" v-if="tableSet.loading" />
              <base-table :key="tableKey" v-else :tableSource="tableSet"></base-table>
            </div>
         </div>
         <div class="col-7 pl5">
            <div class="block-item poi fix">
              <span class="block-item-title l">采购申请</span>
               <q-btn flat class="r mt5 my-text-btn" size='xs' label="生成订单" @click="createBill"></q-btn>
               <q-btn flat class="r mt5 my-text-btn" size='xs' label="匹配" @click="ppFun"></q-btn>
               <q-btn flat class="r mt5 my-text-btn" size='xs' label="批量填充" @click="allInput"></q-btn>
                <q-btn flat class="r mt5 my-text-btn" size='xs' label="删除行" @click="delFun"></q-btn>
              <q-checkbox class="r mr10" v-model="auto_complement" size='xs' label="追加行" left-label :false-value="0" :true-value="1">
               </q-checkbox>
               <q-checkbox class="r mr10" v-model="isAutoDiscount" size='xs' label="自动" left-label false-value="0" true-value="1">
               </q-checkbox>
            </div>
            <div>
              <q-skeleton :height="tableSet2.height" v-if="tableSet2.loading" />
              <base-table ref="baseTableRef" :key="tableKey" v-else :tableSource="tableSet2"></base-table>
            </div>
         </div>
      </div>
    </span>
    <purchase-dialog ref="purchaseDialog" @hadleOk="hadleOk"></purchase-dialog>
  </div>
</template>

<script>
import BaseForm from '@/components/pieces/form/row-col-base2.vue';
import BaseTable from '@/components/pieces/tables/edit-table.vue';
import okDialog from '@/components/pieces/dialog/del-dialog';
import {useStore} from "vuex";
import {computed, nextTick, onMounted, ref, watch} from 'vue';
import {getRandomString,isEmpty} from '@/tools/utils';
import { tableHeight } from "@/tools/lines.js";
import {useRoute} from "vue-router";
import {DEFAULT_NOVAlUE_ROW} from "@/tools/common-rfq.js";
import {checkPermission} from '@/tools/permission.js';
import {isNotEmpty} from "@/tools/utils";
import purchaseDialog from './purchase-dialog.vue';
export default {
  name: "eorderDetails",
  components:{ BaseForm,BaseTable,purchaseDialog},
  provide(){
    return {
      formSet:{data:this.formSet},
      baseData:this.baseData,
      // tableSource:this.tableSet,
      madData:this.madData
    }
  },
  setup(){
    const store = useStore();
    const route =  useRoute();
    let tableKey = ref(getRandomString(8));
    let pageKey = ref(getRandomString(8));
    let key = ref('');//当前页面跳转的key
    let routerParams= ref({});//当前页面携带参数
    let formSet = store.getters['eorderetails/getFormSet'];//表单配置
    let formSet2 = store.getters['eorderetails/getFormSet2'];//表单配置
    let baseData = store.getters['eorderetails/getBaseData'];
    let tableSet = computed(() => store.getters['eorderetails/getTableSet']);
    let tableSet2 = computed(() => store.getters['eorderetails/getTableSet2']);
    let madData = computed(() => store.getters['madValueSet/getMadData']);
    let okDialog = ref();
    let purchaseDialog = ref();
    let isShowBlock1 = ref(false);
    let isShowBlock3 = ref(true);
    let isAutoDiscount = ref('1');
    let auto_complement = ref(1);
    let allDelRow = ref([]);
    function initPage(){
      refreshTableHeight();
      window.onresize = () => {
        return (() => {
          refreshTableHeight();
        })();
      };
    }
    function createBill(){
      formSet.body[0].items.forEach((item)=>{
        item.msg = '';
      });
      if(isEmpty(tableSet2.value.data)){
        store.dispatch("response/set-api-response", {errorMessage:'采购申请空无法生成订单!'}, { root: true });
        return
      }
      let delArr = [...allDelRow.value];
      let params = {
        sprno:route.params.id,
        del_lines:delArr,
        auto_complement:auto_complement.value,
        billnos:[],
        customer_fields:{}
      };
      tableSet2.value.data.forEach((item)=>{
        isNotEmpty(item.FPRBILLNO) && params.billnos.push(item.FPRBILLNO);
      });
      let hasRequired = [];
      formSet.body[0].items.forEach((item)=>{
        if(item.isDiy){
          params.customer_fields[item.name] = item.value;
          if(item.required && isEmpty(item.value)){
            item.msg = '不能为空！'
            hasRequired.push(item);
          }
        }
      });
      if(isNotEmpty(hasRequired)){
        return;
      }
      let data = {'VBELN':'', 'POSNR': '','MATNR': '', 'KWMENG': '',"KUNWE":""}
      params.KUNWE_item = [];
      tableSet2.value.data.forEach((item)=>{
        let obj = JSON.parse(JSON.stringify(data));
        obj.VBELN = item.sono;
        obj.POSNR = item.so_lineid;
        obj.MATNR = item.MATNR;
        obj.KWMENG = item.FQTY;
        obj.KUNWE = item.KUNWE;
        obj.EDATU = item.EDATU;
        params.KUNWE_item.push(obj);
      });
      store.dispatch('eorderetails/makeOrder',params)
    }
    let baseTableRef = ref();
    function allInput(){
      baseTableRef.value.isRowEdit = true;
      if(isEmpty(baseTableRef.value?.editCell?.colName)){
        store.dispatch("response/set-api-response", {errorMessage:'未选中要向下填充的单元格!'}, { root: true });
        return;
      }
      console.log(baseTableRef.value.editCell.colName,'456');
      if(['EDATU','KUNWE'].includes(baseTableRef.value.editCell.colName)){
        tableSet2.value.data.forEach((item,index)=>{
          if(index > baseTableRef.value.editCell.rowIndex){
            item[baseTableRef.value.editCell.colName] =  tableSet2.value.data[baseTableRef.value.editCell.rowIndex][baseTableRef.value.editCell.colName];
          }
        });
      }
    }
    function ppFun(){
      if(isAutoDiscount.value == '1'){
        allDelRow.value =[];
        store.dispatch('eorderetails/makeDry',{
          sprno:route.params.id,
          auto_complement:auto_complement.value
        });
      }else{
        purchaseDialog.value.open()
      }
    }
    function hadleOk(rowsData){
      let params = {
        sprno:route.params.id,
        billnos:[],
        auto_complement:auto_complement.value
      };
      rowsData.forEach(item=>{
        params.billnos.push(item.FPRBILLNO);
      });
      allDelRow.value =[];
      store.dispatch('eorderetails/makeDry',params);
    }
    function delFun(){
      if(!isNotEmpty(tableSet2.value.selected)){
        store.dispatch("response/set-api-response", {errorMessage:'请勾选采购申请后点击删除!'}, { root: true });
        return
      }
      let hasId = [];
      let notHasId = [];
      tableSet2.value.selected.forEach(item=>{
        if(isNotEmpty(item.FPRBILLNO)){
          hasId.push(item);
        }else{
          notHasId.push(item.rowNo);
        }
      });
      if(isNotEmpty(notHasId)){
        store.commit('eorderetails/removePOData',notHasId)
      }
      if(!isNotEmpty(hasId)){
        return;
      }
      let delArr = [...allDelRow.value,...hasId]
      let params = {
        sprno:route.params.id,
        del_lines:delArr,
        auto_complement:auto_complement.value,
        billnos:[]
      };
      allDelRow.value = delArr;
      tableSet2.value.data.forEach((item)=>{
        isNotEmpty(item.FPRBILLNO) && params.billnos.push(item.FPRBILLNO);
      });
      store.dispatch('eorderetails/makeDry',params);
    }
    async function init(){
      store.dispatch('eorderetails/getEorderDetails',{id:route.params.id})
    }
    /**
     * 刷新表格高度
     */
    function refreshTableHeight() {
      store.commit("eorderetails/refreshTableHeight", tableHeight()-110);
    }
    onMounted(()=>{
      init();
      initPage();
      store.commit("eorderetails/clearData");
    });
    return{
      tableKey,
      tableSet,
      tableSet2,
      formSet,
      okDialog,
      baseData,
      pageKey,
      madData,
      key,
      isShowBlock1,
      isShowBlock3,
      isAutoDiscount,
      auto_complement,
      ppFun,
      delFun,
      purchaseDialog,
      hadleOk,
      formSet2,
      createBill,
      baseTableRef,
      allInput
    }
  },
}
</script>

<style scoped lang="scss">

.rfq-inquiry-list{
  .header-style{
    border-bottom: 2px solid #EEEEEE;
    font-size: 16px;
    font-weight: 600;
    .header-style-title{
      color:#42A5F5;
    }
  }
}
.bw{
  background-color: white;
}
.p10{
  padding: 10px;
}
.pt10{
  padding-top: 10px;
}
.p5{
  padding: 5px;
}
.m5{
  margin: 5px;
}
.mb5{
  margin-bottom: 5px;
}
.br5{
  border-radius: 5px;
}
.l {
  float: left;
}
.r {
  float: right;
}
.fix{*zoom:1;}
.fix:after{display:table; content:''; clear:both;}
.my-text-btn:hover{
  color: #42A5F5;
}
</style>

